module.exports = __webpack_public_path__ + "static/media/cq_simulatore.7d6e8a27.svg";